module.exports = __webpack_public_path__ + "static/media/portals.4082480c.svg";